// This file was auto generated by resource-sync tools.

import ar_b_pc_rider_pc from './ar/b_pc_rider_pc.json';
import en_b_pc_rider_pc from './en/b_pc_rider_pc.json';
import zh_b_pc_rider_pc from './zh/b_pc_rider_pc.json';


const resources = {
    'namespaces': 
    [{"localeInfos":[{"locale":"ar","version":19},{"locale":"en","version":27},{"locale":"zh","version":17}],"i18nConfig":{"apiKey":"5960afab14104e319ab1a7db5057e908","projectId":43,"namespaceId":"xiseqyo75q","namespaceName":"b_pc_rider_pc"}}],
    'ar': {
        b_pc_rider_pc: ar_b_pc_rider_pc
    },
    'en': {
        b_pc_rider_pc: en_b_pc_rider_pc
    },
    'zh': {
        b_pc_rider_pc: zh_b_pc_rider_pc
    }
};

export default resources;